<template>
	<div class="header-wrapper">
		<div class="edit-header">
			<div class="edit-header--left">
				<div class="title is-5 is-bold">
					<span v-if="!isPublished">New tutorial</span>
					<span v-if="isPublished">Edit tutorial</span>
				</div>
			</div>
			<div class="edit-header--center">
				<transition name="spinner-fade" mode="out-in">
					<loading-spinner v-if="isLoading"
						class="edit-header__spinner"
						:status="loadingStatus">
					</loading-spinner>
				</transition>
			</div>
			<div class="edit-header--right" v-if="!isPublished">
				<a class="edit-header__link btn btnText btnLg" @click="updateTutorial" v-bind:class="{'disabled': isLoading}">Save</a>
				<a class="edit-header__link btn btnText btnLg" href="/tutorials">Cancel</a>
				<button @click.prevent="validateSave()" v-if="!isNew" class="edit-header__button btn btnLg btnRed" :disabled="isLoading">Publish</button>
			</div>
			<div class="edit-header--right" v-if="isPublished">
				<a class="edit-header__link btn btnLg btnText" v-bind:href="publishedUrl">Cancel</a>
				<button @click.prevent="validateSave()" class="edit-header__button btn btnLg btnRed" :disabled="isLoading">Save</button>
			</div>
		</div>
		<Recaptcha />
	</div>
</template>

<script>
	import Recaptcha from './Recaptcha'
	import LoadingSpinner from './LoadingSpinner'
	import { mapGetters, mapActions } from 'vuex'

	export default {
		name: 'app-header',
		components: { LoadingSpinner, Recaptcha },
		computed: {
			...mapGetters([
				'isNew',
				'isLoading',
				'isPublished',
				'loadingStatus',
				'publishedUrl'
			])
		},
		methods: {
			...mapActions(['updateTutorial']),
			validateSave () {
				this.$eventHub.$emit('validate')
			}
		}
	}
</script>
